//https://jsperf.com/alternative-isfunction-implementations
export function isFunction(obj) {
    return !!(obj && obj.constructor && obj.call && obj.apply);
}
